
<template>
	<div class="widget-card">
		<h2 class="text-center">{{ widget.dashboardwidgets_title }}</h2>

		<LoadingSpinner v-if="loading" />
		<Apexchart
			v-else
			type="line"
			height="400"
			:options="chartOptions"
			:series="series"
		/>
	</div>
</template>

<script type="text/javascript">
import VueApexCharts from 'vue-apexcharts'
import Common from '@/assets/js/common.js'
import InvoiceMixin from '@/mixins/Invoice.js'

export default {
	name: 'WidgetCA',
	mixins: [InvoiceMixin],
	props: ['widget'],
	data() {
		return {
			loading: true,
			series: [],
			chartOptions: {},
		}
	},

	mounted() {
		this.loadData()
	},

	methods: {
		toCumulative(monthlyData) {
			let acc = 0
			return monthlyData.map(v => Math.round(acc += v))
		},
		async loadData() {
			this.loading = true
			const config = this.widget.dashboardwidgets_config
			const caType = config.type_ca || 'ca_total'
			const accountingPlanId = config.entite
			const objectif = config.objectif_ca || null

			const y = new Date().getFullYear()
			const data = await this.loadInvoiceWidgetCA(accountingPlanId, y)

			const aggregateByMonth = (invoices) => {
				const months = Array(12).fill(0)
				for (const inv of invoices) {
					if (caType === 'ca_monte' && !inv.invoice_saillie) continue
					if (caType === 'ca_pension' && !inv.invoice_has_pension) continue
					months[new Date(inv.invoice_date).getMonth()] += inv.invoice_ttc || 0
				}
				return months
			}

			const currentYearData = aggregateByMonth(data ? data.current_year : [])
			const prevYearData = aggregateByMonth(data ? data.prev_year : [])
			const currency = data ? data.currency : null
			const prevY = y - 1

			const currentMonth = new Date().getMonth() + 1
			const currentYearCumulative = this.toCumulative(currentYearData).map((v, i) => i < currentMonth ? v : null)

			const series = [
				{ name: `CA ${prevY}`, data: this.toCumulative(prevYearData) },
				{ name: `CA ${y}`, data: currentYearCumulative },
			]
			if (objectif) {
				series.push({
					name: this.$t('cards.widget.ca_objectif') + ` ${y}`,
					data: Array(12).fill(objectif),
				})
			}

			const months = Array.from({ length: 12 }, (_, i) =>
				new Intl.DateTimeFormat('fr-FR', { month: 'short' }).format(new Date(2000, i, 1))
			)
			const { currency_symbol: symbol } = await Common.getCurrency(currency)

			this.series = series
			this.chartOptions = {
				chart: { type: 'line', toolbar: { show: false }, zoom: { enabled: false }, foreColor: '#ACB2BC' },
				stroke: { curve: 'smooth', width: series.map(() => 2), dashArray: series.map((_, i) => i === 2 ? 6 : 0) },
				dataLabels: { enabled: false },
				xaxis: {
					categories: months,
					title: { text: this.$t('cards.widget.ca_xaxis') },
				},
				yaxis: {
					title: { text: `${this.$t('cards.widget.ca_yaxis')} (${symbol})` },
					labels: { formatter: val => `${Math.round(val / 1000)}k ${symbol}` },
				},
				colors: ['#2E93fA', '#DC1258', '#FFDB58'],
				legend: { position: 'top' },
				tooltip: {
					y: { formatter: val => val != null ? `${val} ${symbol}` : '' },
				},
			}
			this.loading = false
		},
	},

	components: {
		Apexchart: VueApexCharts,
		LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
	},
}
</script>
